var _ = require('underscore');

// Add string formatting if it doesn't exist
if (!String.prototype.format) {
  String.prototype.format = function() {
    var args = arguments;
    return this.replace(/{(\d+)}/g, function(match, number) {
      return typeof args[number] != 'undefined'
        ? args[number]
        : match
      ;
    });
  };
}

function getWaterTempProbe(data, plotInfo, traceInfo, allData) {
    var allProbeText = [];
    var probeText;
    var row, col;
    var rowText;
    var depth;
    for (var j=0; j < data.length; j++) {
        row = data[j];
        rowText = [];
        depth = traceInfo.y[j];
        for (var i=0; i < row.length; i++) {
            col = row[i];

            probeText = "Depth: {0}m<br>{1}: {2} °C ({3} °F)".format(
                depth.toFixed(1),
                traceInfo.name,
                col !== null ? col.toFixed(3) : "N/A",
                col !== null ? getF(col).toFixed(3) : "N/A");
            rowText.push(probeText);
        }
        allProbeText.push(rowText);
    }
    return allProbeText;
}

function getSpeedMPH(val) {
    // convert m/s to mph
    return val * 3600 / 1608;
}
function getSpeedKnotsToMPH(val) {
    // convert knots to mph
    return val * 1.15078;
}
function getSpeedKTS(val) {
    //m/s to knots
    return val * 1.94384;
}


function getPresInHg(val) {
    // hPa to InHg
    return val * 0.02952998751;
}


function getAccumMillimeter(val) {
    // convert inches to millimeters
    return val * 25.4;
}
function getAccumMillimeterToInches(val) {
    // convert millimeters to inches
    return val / 25.4;
}


function cardinalWDir(degrees){
    if (isNaN(degrees)) {
        return "N/A";
    }
    return ['N','NNE','NE','ENE',
            'E','ESE','SE','SSE',
            'S','SSW','SW','WSW',
            'W','WNW','NW','NNW'][Math.floor(((degrees+11.25)%360)/22.5)];
}
// Convert C to F degrees
function getF(val) {
    return val * 1.8 + 32;
}

function getVal(val) {
    return val;
}


var CONVERSION_FUNCTIONS = {
    null: getVal,
    undefined: getVal,
    getF: getF,
    getPresInHg: getPresInHg,
    getSpeedMPH: getSpeedMPH,
    getSpeedKnotsToMPH: getSpeedKnotsToMPH,
    getAccumMillimeter: getAccumMillimeter,
    getAccumMillimeterToInches: getAccumMillimeterToInches,
    cardinalWDir: cardinalWDir,
    getSpeedKTS:getSpeedKTS
};



function formatValue(val, plotInfo, traceInfo) {
    var val2;
    if (val === null) {
        val = "";
        val2 = "";
    } else {
        if ('yaxis2' in plotInfo && 'convert_value' in plotInfo.yaxis2) {
            val2 = CONVERSION_FUNCTIONS[plotInfo.yaxis2.convert_value](val);
            val2 = (val2.toFixed)?val2.toFixed(plotInfo.yaxis2.precision):val2;
        } else {
            val2 = undefined;
        }
        val = CONVERSION_FUNCTIONS[plotInfo.yaxis.convert_value](val);
        val=(val.toFixed)?val.toFixed(plotInfo.yaxis.precision):val;
    }

    if ('yaxis2' in plotInfo && val2 !== undefined) {
        return "{0}: {1}{2} ({3}{4})".format(
            traceInfo.name,
            val, plotInfo.yaxis.units,
            val2, plotInfo.yaxis2.units);
    } else {
        return "{0}: {1}{2}".format(
            traceInfo.name,
            val, plotInfo.yaxis.units);
    }
}

function getDewpointProbe(data, plotInfo, traceInfo, allData) {
    var allProbeText = [];
    var probeText;
    var relHum = undefined;
    if ('anc_variables' in traceInfo && traceInfo.anc_variables.length == 1) {
        relHum = allData[traceInfo.anc_variables[0]];
    }
    var rh_info = traceInfo.anc_info[traceInfo.anc_variables[0]];
    if(!rh_info)
        rh_info={ name: traceInfo.anc_variables[0], units: '', precision: 2};

    for (var i=0; i < data.length; i++) {
        probeText = formatValue(data[i], plotInfo, traceInfo);
        if (relHum !== undefined) {
            probeText += "<br>{0}: {1}{2}".format(rh_info.name,
                    relHum[i] ? relHum[i].toFixed(rh_info.precision) : "",
                    rh_info.units);
        }
        allProbeText.push(probeText);
    }
    return allProbeText;
}


function defaultProbeText(data, plotInfo, traceInfo, allData) {
    // assume traces share the same 'x'
    var allProbeText = [];
    for (var i=0; i < data.length; i++) {
        allProbeText.push(formatValue(data[i], plotInfo, traceInfo));
    }
    return allProbeText;
}


var PROBE_TEXT_FUNCTIONS = {
    undefined: defaultProbeText,
    null: defaultProbeText,
    dewpoint: getDewpointProbe,
    water_temp: getWaterTempProbe,
};


function getProbeText(data, plotInfo, traceInfo, allData) {
    if ('probe_text' in traceInfo) {
        return PROBE_TEXT_FUNCTIONS[traceInfo.probe_text](data, plotInfo, traceInfo, allData);
    }
    return defaultProbeText(data, plotInfo, traceInfo, allData);
}


function getTickText(values, axis_info) {
    var tickText = [];
    for (var i=0; i < values.length; i++) {
        var val = CONVERSION_FUNCTIONS[axis_info.convert_value](values[i]);
        val = (val.toFixed)?val.toFixed(axis_info.precision):val;
        tickText.push(val);
    }
    return tickText;
}


/**
* the purpose of this method is to get the spacing for the y axis
* For deg F and deg C
* @param min - minimum of the temp or dew point array
* @param max - maximum of the temp or dew point array
* @return array of 4 tick values for the y axis
*/

function getTickVals(min, max, bump) {
    var extra = (max - min) * 0.02;
    min = min - extra;
    max = max + extra;
    var step = (max - min) / 4.;
    //create 4 tick values for the y axis
    return _.range(min, max + step, step);
}


function preConvertValue(values, axis_info) {
    /**
     * Convert values before inserting them into the final storage array.
     */
    if (!('preconvert_value' in axis_info)) {
        return;
    }
    var val;
    for (var i=0; i < values.length; i++) {
        val = CONVERSION_FUNCTIONS[axis_info.preconvert_value](values[i]);
        val = (val.toFixed)?val.toFixed(axis_info.precision):val;
        values[i] = val;
    }
}


module.exports.getTickVals = getTickVals;
module.exports.getProbeText = getProbeText;
module.exports.getTickText = getTickText;
module.exports.preConvertValue = preConvertValue;




